import { render } from "./IndexWhitelist.vue?vue&type=template&id=7fa1b71b"
import script from "./IndexWhitelist.vue?vue&type=script&lang=js"
export * from "./IndexWhitelist.vue?vue&type=script&lang=js"

import "./IndexWhitelist.vue?vue&type=style&index=0&id=7fa1b71b&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__